<template>
  <div class="bg-background-yellow">
    <div class="container">
      <div class="m:flex m:items-center m:justify-between">
        <div class="py-6 m:py-11">
          <b-headline type="h1" typography="h15" class="mb-6 m:mb-8 m:pt-5" v-html="$t('connect')" />
        </div>
        <faq-image class="hidden m:flex justify-end w-2/3" />
      </div>
    </div>
    <faq-image class="w-full m:hidden" />
  </div>
</template>

<script>
import FaqImage from "./faq-image"
import BHeadline from "@/component-library/b-headline"

export default {
  name: "ConnectFaqHeroSection",
  components: {
    FaqImage,
    BHeadline
  },
  i18n: {
    messages: {
      en: {
        connect: "Spaces"
      },
      de: {
        connect: "Spaces"
      }
    }
  }
}
</script>
